import { render } from "./TuiKuanCheck.vue?vue&type=template&id=4e3c5a1e"
import script from "./TuiKuanCheck.vue?vue&type=script&lang=js"
export * from "./TuiKuanCheck.vue?vue&type=script&lang=js"

import "./TuiKuanCheck.vue?vue&type=style&index=0&id=4e3c5a1e&lang=less"

import exportComponent from "D:\\fxwl\\wx-wl_full\\wx-wl_full\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__